import {Options} from "highcharts";
import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";

export class Bar extends AbstractChart {
    protected allChartOptions(): Options {
        const options: Options = {
            chart: {
                type: 'bar'
            },
            xAxis: {
                labels: {
                    enabled: this.isLongitudinal()
                }
            }
        }

        return super.mergeOptions(super.allChartOptions(), options);
    }
}

export default function () {registerPlugin(Bar)}